import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["productLine", "productLevel"];
import UIImage from 'UIComponents/image/UIImage';
import get from 'hs-lodash/get';
import { memo } from 'react';
import { getProductLineIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import { getProductTierToIconMap } from '../../constants/merchCards/ProductToIconMap';
import { jsx as _jsx } from "react/jsx-runtime";
const ProductIcon = _ref => {
  let {
      productLine,
      productLevel
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const productIcons = getProductLineIcons();
  const productTierIcons = getProductTierToIconMap();
  if (productLevel) {
    const icon = get(productTierIcons, [productLine, productLevel], null);
    return icon ? /*#__PURE__*/_jsx(UIImage, Object.assign({
      src: icon
    }, rest)) : null;
  }
  return /*#__PURE__*/_jsx(UIImage, Object.assign({
    src: productIcons[productLine]
  }, rest));
};
export default /*#__PURE__*/memo(ProductIcon);